module.exports = __webpack_public_path__ + "img/mvip_ok.b13c1571.png";